<unesp-core-layout fullTitle="{{fullTitle}}" shortTitle="{{shortTitle}}" logoCustom="{{logoCustom}}" [footer]="footer">
  <div class="ngcontent-router" [@routeAnimations]="prepareRoute(outlet)" style="padding: 20px;">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</unesp-core-layout>

